'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _cartApi = require('../../cartApi');

var _cartApi2 = _interopRequireDefault(_cartApi);

var _providerEvents = require('wix-art-store-3rd-party/dist/src/sdk/providerEvents');

var _providerEvents2 = _interopRequireDefault(_providerEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-case-declarations */
exports.default = function (type, payload, resolve, reject, providerId) {
  switch (type) {
    // case providerEvents.addToCart:
    //   break;
    case _providerEvents2.default.updateCartItem:
      var itemUuid = payload.uuid;
      var metadata = payload.metadata;
      var quantity = payload.quantity;

      _cartApi2.default.updateCartItem(itemUuid, metadata, quantity);
      break;

    case _providerEvents2.default.clearCart:
      _cartApi2.default.clearCart();
      break;
    case _providerEvents2.default.removeFromCart:
      var uuid = payload.uuid;

      _cartApi2.default.removeFromCart(uuid);
      break;

    case _providerEvents2.default.getCartItems:
      var options = payload.options;


      _cartApi2.default.getCartItems(providerId, (0, _assign2.default)({}, options)).then(function (items) {
        resolve(items);
      });
      break;
    default:
      break;
  }
};
/* eslint-enable no-case-declarations */